import { render, staticRenderFns } from "./MarkupTable.vue?vue&type=template&id=45cf51eb&lang=pug&"
import script from "./MarkupTable.vue?vue&type=script&lang=js&"
export * from "./MarkupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports